import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    modules: {},
    state: {
        adywOpenId: localStorage.getItem("adywOpenId") || '',
        ayyOpenId: localStorage.getItem("ayyOpenId") || '',
        wxUserInfo: localStorage.getItem("wxUserInfo")?JSON.parse(localStorage.getItem("wxUserInfo")):[],
        userInfo: localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):[],
        cinemaUserInfo: localStorage.getItem("cinemaUserInfo")?JSON.parse(localStorage.getItem("cinemaUserInfo")):[],
        isPerfect: localStorage.getItem("isPerfect") || false
    },
    mutations: {
        setAyyOpenId(state, info) {
            state.ayyOpenId = info;
            localStorage.setItem('ayyOpenId', info)
        },
        setIsPerfect(state, info) {
            state.isPerfect = info;
            localStorage.setItem('isPerfect', info)
        },
        setAdywOpenId(state, info) {
            state.adywOpenId = info;
            localStorage.setItem('adywOpenId', info)
        },
        setWxUserInfo(state, info){
            state.wxUserInfo = info;
            localStorage.setItem('wxUserInfo', JSON.stringify(info));
        },
        setUserInfo(state, info){
            state.userInfo = info;
            localStorage.setItem('userInfo', JSON.stringify(info));
        },
        setCinemaUserInfo(state, info){
            state.cinemaUserInfo = info;
            localStorage.setItem('cinemaUserInfo', JSON.stringify(info));
        } 
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js